import axios from "axios";
import AxiosConfigs from "../configs/axios";

const { REACT_APP_LINK_HOST: apiUrl } = AxiosConfigs;

export const instance = axios.create({ baseURL: apiUrl + "/api" });

/*
  axios.defaults.withCredentials = true;
*/

export const request = async ({ ...options }) => {
  const authToken = localStorage.getItem("token");

  instance.defaults.headers = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    ...(authToken && { Authorization: `Bearer ${authToken}` }),
    ...options.headers,
  };

  return new Promise((resolve, reject) => {
    instance(options)
      .then((response) => resolve(response))
      .catch((error) => {
        if (error && error.response && error.response.status === 401) {
          // Only logout on 401 when it's app auth failure, not Zapier token failure.
          // Zapier profile/me 401 means the Zapier token is expired; don't sign the user out.
          const requestUrl = error.config?.url || "";
          const isZapierRequest = String(requestUrl).includes("/zapier/");
          if (!isZapierRequest) {
            localStorage.removeItem("token");
            window.location.replace("/signout");
          }
        }

        reject(error);
      });
  });
};
